// extracted by mini-css-extract-plugin
module.exports = {"modalTable":"styles_modalTable__3YULY","tdCheckbox":"styles_tdCheckbox__3SaW7","tdStatus":"styles_tdStatus__DTquN"};